module.exports = __webpack_public_path__ + "img/ID.a8161cf2.svg";